module.exports = __webpack_public_path__ + "fonts/AvenyTWEB.5ff4db62.woff";